<template>
  <div class="Container">
    <h2 class="ViewHeading">Track manual flushing</h2>
    <br />
    <b-card>
      <b-table
        :items="this.NewFlushList"
        :fields="fields"
        striped
        responsive="sm"
        empty-text="Press button to add manual flushes for tracking"
        show-empty
      >
        <template #cell(show_details)="row">
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="row.toggleDetails"
          >
            {{ row.detailsShowing ? "Hide" : "Show" }} Details
          </b-button>
        </template>

        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Type:</b></b-col>
              <b-col>{{ row.item.Type }}</b-col>
            </b-row>

            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Flush Date:</b></b-col>
              <b-col>{{ row.item.FlushDate }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Flush Time:</b></b-col>
              <b-col>{{ row.item.FlushTime }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Flushed By:</b></b-col>
              <b-col>{{ row.item.FlushName }}</b-col>
            </b-row>
            <b-row>
              <b-col
                ><b-button
                  variant="outline-secondary"
                  size="sm"
                  @click="row.toggleDetails"
                  >Hide Details</b-button
                ></b-col
              >
              <b-col
                ><b-button
                  variant="outline-danger"
                  size="sm"
                  @click="removeFlush(row.item)"
                  >Remove Row</b-button
                ></b-col
              >
            </b-row>
          </b-card>
        </template>
      </b-table>
    </b-card>
    <b-row>
      <b-col
        ><b-button
          variant="outline-success"
          size="sm"
          v-on:click="addNewFlush()"
          ><BIconPlusSquare></BIconPlusSquare> New Flush</b-button
        ></b-col
      >
    </b-row>
    <br />
    <b-row class="text-center"
      ><b-col
        ><b-button variant="outline-info" v-on:click="SubmitFlushes()"
          >Submit Manual Flushes</b-button
        ></b-col
      ></b-row
    >

    <b-modal
      ref="SelectDeviceModal"
      id="SelectDeviceModal"
      hide-footer
      title="Select Device for Flush"
      content-class="Modal"
    >
      <b-card>
        <p>Select Device to Register Flush</p>
        <br />
        <b-select v-model="selectedDevice" :select-size="4">
          <option
            v-for="Device in this.DeviceList"
            v-bind:value="Device"
            v-bind:key="Device.DeviceName"
            >{{ Device.DeptArea }} - {{ Device.DeviceName }} ({{
              Device.DeviceType
            }})</option
          >
        </b-select>
        <br />
        <b-row v-if="selectedDevice == null"
          ><b-col><p>No Device Selected</p></b-col></b-row
        >
        <b-row v-if="selectedDevice != null"
          ><b-col cols="2"
            ><p>{{ selectedDevice.DeviceType }}</p></b-col
          ><b-col
            ><p>
              {{ selectedDevice.DeptArea }} - {{ selectedDevice.DeviceName }}
            </p></b-col
          ></b-row
        >
        <br />
        <b-row>
          <b-col cols="4"
            ><b-button
              size="sm"
              id="SelectDeviceButton"
              v-on:click="SubmitDevice()"
              variant="outline-info"
              >Select Device</b-button
            ></b-col
          >
          <b-col></b-col>
          <b-col cols="4"
            ><b-button
              size="sm"
              id="CancelDeviceButton"
              v-on:click="CancelDevice()"
              variant="outline-info"
              >Cancel</b-button
            ></b-col
          >
        </b-row>
      </b-card>
    </b-modal>
    <b-modal
      ref="AddFlushModal"
      id="AddFlushModal"
      hide-footer
      title="Add New Flush"
      content-class="Modal"
    >
      <b-card>
        <br />
        <b-row>
          <b-col class="bodycol" cols="4">Type</b-col>
          <b-col class="bodycol" cols="8">{{ NewFlush.Type }}</b-col>
        </b-row>
        <b-row>
          <b-col class="bodycol" cols="4">Device ID</b-col>
          <b-col class="bodycol" cols="8">{{ NewFlush.Device }}</b-col>
        </b-row>
        <b-row>
          <b-col class="bodycol" cols="4">Area/Dept</b-col>
          <b-col class="bodycol" cols="8">{{ NewFlush.AreaDept }}</b-col>
        </b-row>
        <b-row class="inputRow">
          <b-col class="bodycol" cols="4">Flush Date</b-col>
          <b-col class="bodycol" cols="8">
            <b-form-datepicker v-model="NewFlush.FlushDate"></b-form-datepicker>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="bodycol" cols="4">Flush Time</b-col>
          <b-col class="bodycol" cols="8">
            <b-form-timepicker v-model="NewFlush.FlushTime"
              now-button
              locale="en">
            </b-form-timepicker>
          </b-col>
        </b-row>
        <b-row class="inputRow">
          <b-col class="bodycol" cols="4">Flushed By</b-col>
          <b-col class="bodycol" cols="8">
            <b-form-input
              v-model="NewFlush.FlushName"
              placeholder="Enter Name"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4"
            ><b-button
              size="sm"
              class="button"
              id="button"
              v-on:click="SubmitFlushModal()"
              variant="outline-info"
              >Submit</b-button
            ></b-col
          >
          <b-col></b-col>
          <b-col cols="4"
            ><b-button
              size="sm"
              class="button"
              id="button"
              v-on:click="CancelFlushModal()"
              variant="outline-info"
              >Cancel</b-button
            ></b-col
          ></b-row
        >
      </b-card>
      <br />
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { BIconPlusSquare } from "bootstrap-vue/dist/bootstrap-vue.esm";

export default {
  computed: {},
  components: {
    BIconPlusSquare,
  },

  data() {
    return {
      fields: ["Device", "AreaDept", "show_details"],
      DeviceList: [],
      dataToDisplay: [],
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("ProfilePortal"),
      clCompany: localStorage.getItem("Company"),
      nickname: localStorage.getItem("Nickname"),
      selectedlocation: localStorage.getItem("location"),
      NoOfRows: 1,
      NewFlushList: [],
      NewFlush: {
        Type: null,
        Device: null,
        AreaDept: null,
        FlushDate: null,
        FlushTime: null,
        FlushName: null,
        LocationID: null,
        DeviceID: null,
      },
      selectedDevice: null,
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "DevicesWithNames",
      Location: this.selectedlocation,
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        let DeviceData = response.data.Values;
        for (let i = 0; i < DeviceData.length; i++) {
          let TempDeviceType = DeviceData[i][4];
          let TempDeviceName = DeviceData[i][1];
          let TempDeptArea = DeviceData[i][3];
          let TempDeviceID = DeviceData[i][0];
          let TempDeviceLocation = DeviceData[i][2];

          this.DeviceList.push({
            DeviceType: TempDeviceType,
            DeviceName: TempDeviceName,
            DeptArea: TempDeptArea,
            DeviceID: TempDeviceID,
            DeviceLocation: TempDeviceLocation,
          });
        }
      });
  },

  methods: {
    addNewFlush() {
      (this.NewFlush = {
        Type: null,
        Device: null,
        AreaDept: null,
        FlushDate: null,
        FlushTime: null,
        FlushName: null,
        LocationID: null,
        DeviceID: null,
      }),
        this.$refs["SelectDeviceModal"].show();
    },
    removeFlush(item) {
      this.NewFlushList.splice(item, 1);
      alert("Flush Removed");
    },
    AcceptTerms() {},
    DeclineTerms() {},
    SubmitFlushes() {
      if (this.NewFlushList.length == 0) {
        alert("No Flushes to Submit");
        return;
      } else
        this.SubmitRequest = {
          RequestType: "AddManualFlushes",
          DataDict: [{ FlushList: this.NewFlushList }],
        };

      let SubmitUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/manualinputs";
      let SubmitHeaders = this.$apikeyPost;

      axios
        .post(SubmitUrl, this.SubmitRequest, SubmitHeaders)
        .then((response) => {
          response;
        });

      alert("Flushes Submitted Successfully ");
      this.NewFlushList = [];
    },
    SubmitDevice() {
      if (this.selectedDevice == null) {
        alert("Please select a Device first");
      } else this.$refs["SelectDeviceModal"].hide();
      (this.NewFlush = {
        Type: this.selectedDevice.DeviceType,
        Device: this.selectedDevice.DeviceName,
        AreaDept: this.selectedDevice.DeptArea,
        FlushDate: null,
        FlushTime: null,
        FlushName: null,
        LocationID: this.selectedDevice.DeviceLocation,
        DeviceID: this.selectedDevice.DeviceID,
      }),
        this.$refs["AddFlushModal"].show(),
        (this.selectedDevice = null);
    },
    CancelDevice() {
      this.selectedDevice = null;
      (this.NewFlush = {
        Type: null,
        Device: null,
        AreaDept: null,
        FlushDate: null,
        FlushTime: null,
        FlushName: null,
        LocationID: null,
        DeviceID: null,
      }),
        this.$refs["SelectDeviceModal"].hide();
    },
    SubmitFlushModal() {
      if (
        this.NewFlush.Type == null ||
        this.NewFlush.Device == null ||
        this.NewFlush.AreaDept == null ||
        this.NewFlush.FlushDate == null ||
        this.NewFlush.FlushTime == null ||
        this.NewFlush.FlushName == null
      ) {
        alert("Please fill in all fields");
        return;
      } else {
        alert("Flush Submitted");
        this.$refs["AddFlushModal"].hide();
        this.NewFlushList.push(this.NewFlush);
      }
    },
    CancelFlushModal() {
      this.$refs["AddFlushModal"].hide();
      this.NewFlush = {
        Type: null,
        Device: null,
        AreaDept: null,
        FlushDate: null,
        FlushTime: null,
        FlushName: null,
        LocationID: null,
        DeviceID: null,
      };
    },
  },
  created() {},
  watch: {},
};
</script>

<style scoped>
.headercol {
  border-bottom: solid 2px lightgrey;
  font-weight: bold;
  margin: 0;
  padding: 5px;
}
.bodycol {
  padding: 5px;
}
.actionrow {
  margin-left: auto;
  margin-right: auto;
}

.centered {
  text-align: center;
}
</style>
